import Notification from '@rio-cloud/rio-uikit/Notification';

interface NotificationPayload {
    title: string;
    message: string;
    messageType: 'ERROR' | 'INFO' | 'SUCCESS';
}

const handleNotification = (payload: NotificationPayload) => {
    const { messageType, title, message } = payload;
    const typeMethod = messageType.toLowerCase() as Lowercase<typeof messageType>;

    Notification[typeMethod](message, { title });
};

export default handleNotification;
